<div id="loader">
    <div id="preloader" aria-busy="true" aria-label="Loading, please wait." role="progressbar">
        <img class="icon" src="assets/img/loader-img.png">
        <p class="text-center d-block">Please Wait</p>
    </div>
</div>